import { render } from "./EntityView.vue?vue&type=template&id=466d2cba&ts=true"
import script from "./EntityView.vue?vue&type=script&lang=ts"
export * from "./EntityView.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__